import { newToolFilterOAuthMcp } from "../oauth.ts";

export const zineMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.zine.ai/apple-touch-icon.png",
  url: "https://www.zine.ai/mcp",
  label: "Zine",
});
